import { parseAsString, useQueryState } from "nuqs"

export const useSearchTermParam = (paramName = "search") => {
  return useQueryState(
    paramName,
    parseAsString
      .withDefault("")
      .withOptions({ clearOnDefault: true, shallow: false }),
  )
}
